<div class="table-row row-hover">
    <div class="row py-2 align-items-start" (click)="isCollapsed = !isCollapsed">
        <div class="col-1 d-flex justify-content-center align-items-start">
            <fa-icon [icon]="isCollapsed ? faChevronDown : faChevronUp" aria-hidden="true"></fa-icon>
        </div>
        @for (column of columns; track column) {
            <div class="text-break col-lg-3 col-5" [ngClass]="{ 'text-danger': pISparePartExpandableForm.invalid }">
                {{
                    get(column.field).length > 0
                        ? get(column.field)
                        : ('PHYSICAL_INVENTORY_NEW_ENTRY_LABEL' | translate) + ' ' + column.title
                }}
            </div>
        }
    </div>
    <!-- Intentionally using [hidden] instead of *ngIf to avoid re-creation and to display titles correctly based on validation results -->
    <div [hidden]="isCollapsed" [ngClass]="{ collapsed: isCollapsed, expanded: !isCollapsed }">
        <div class="row">
            <label
                class="col-lg-1 col-11 offset-1 col-form-label text-start text-lg-end"
                for="material-description"
                [translate]="'PHYSICAL_INVENTORY_DESCRIPTION_LABEL'"
            ></label>
            @if (row.isEntryDeletable && !row.isBatchNumberRequired) {
                <div class="col-lg-2 col-11 offset-1 offset-lg-0 mb-3">
                    <pace-core-text-input
                        id="material-description"
                        [(model)]="row.description"
                        [parentForm]="formChildren"
                        [ariaLabel]="'PHYSICAL_INVENTORY_DESCRIPTION_LABEL' | translate"
                    >
                    </pace-core-text-input>
                </div>
            } @else {
                <label class="col-lg-2 offset-1 offset-lg-0 col-11 text-start py-2" for="material-description">{{
                    row.description.value
                }}</label>
            }
            <label
                class="col-lg-1 offset-1 offset-lg-0 col-11 col-form-label text-start text-lg-end"
                for="material-no"
                [translate]="'PHYSICAL_INVENTORY_MATERIAL_NO_LABEL'"
            ></label>
            @if (row.isEntryDeletable && !row.isBatchNumberRequired) {
                <div class="col-lg-2 offset-1 offset-lg-0 col-11 mb-3">
                    <pace-core-text-input
                        id="material-no"
                        [(model)]="row.material"
                        [parentForm]="formChildren"
                        [ariaLabel]="'PHYSICAL_INVENTORY_MATERIAL_NO_LABEL' | translate"
                    >
                    </pace-core-text-input>
                </div>
            } @else {
                <label class="col-lg-2 col-11 offset-1 offset-lg-0 text-start py-2" for="material-no">{{
                    row.material.value
                }}</label>
            }
            @if (row.isBatchNumberRequired) {
                <label
                    class="col-lg-1 col-11 offset-1 offset-lg-0 col-form-label text-start text-lg-end"
                    for="batch-number"
                    [translate]="'PHYSICAL_INVENTORY_SPARE_PART_BATCH_NO_LABEL'"
                ></label>
                <div class="col-lg-2 col-11 offset-1 offset-lg-0 mb-3">
                    <pace-core-text-input
                        id="batch-number"
                        [(model)]="row.batchNumber"
                        [parentForm]="formChildren"
                        [ariaLabel]="'PHYSICAL_INVENTORY_SPARE_PART_BATCH_NO_LABEL' | translate"
                    >
                    </pace-core-text-input>
                </div>
            }
        </div>
        <div class="row">
            <label
                class="col-lg-1 col-11 offset-1 col-form-label text-start text-lg-end"
                for="material-document-no"
                [translate]="'PHYSICAL_INVENTORY_SPARE_PART_DOCUMENT_NO_LABEL'"
            ></label>
            @if (row.isEntryDeletable && !row.isBatchNumberRequired) {
                <div class="col-lg-2 col-11 offset-1 offset-lg-0 mb-3">
                    <pace-core-text-input
                        id="material-document-no"
                        [(model)]="row.pIDocNo"
                        [parentForm]="formChildren"
                        [ariaLabel]="'PHYSICAL_INVENTORY_SPARE_PART_DOCUMENT_NO_LABEL' | translate"
                    >
                    </pace-core-text-input>
                </div>
            } @else {
                <label class="col-lg-2 col-11 offset-1 offset-lg-0 text-start py-2" for="material-document-no">{{
                    row.pIDocNo.value
                }}</label>
            }
            <label
                class="col-lg-1 col-11 offset-1 col-form-label offset-lg-0 text-start text-lg-end"
                for="material-quantity"
                [translate]="'PHYSICAL_INVENTORY_SPARE_PART_QUANTITY_LABEL'"
            ></label>
            <div class="col-lg-2 col-11 offset-1 offset-lg-0 mb-3 material-quantity">
                <pace-core-number-stepper
                    id="material-quantity"
                    [(model)]="row.quantity"
                    [parentForm]="formChildren"
                    (valueChange)="updateQuantityValidation(row.quantity.value ?? 0)"
                    [ariaLabel]="'PHYSICAL_INVENTORY_SPARE_PART_QUANTITY_LABEL' | translate"
                ></pace-core-number-stepper>
            </div>
        </div>
        <div class="row">
            <label
                class="col-lg-1 col-11 offset-1 col-form-label text-start text-lg-end"
                for="material-comments"
                [translate]="'PHYSICAL_INVENTORY_COMMENTS_LABEL'"
            ></label>
            <div class="col-lg-5 col-11 offset-1 offset-lg-0 mb-3 py-1">
                <pace-core-text-input
                    id="material-comments"
                    [(model)]="row.comment"
                    [parentForm]="formChildren"
                    [ariaLabel]="'PHYSICAL_INVENTORY_COMMENTS_LABEL' | translate"
                >
                </pace-core-text-input>
            </div>
            @if (row.isEntryDeletable) {
                <div class="col-1 offset-11 mb-3 py-1" [ngClass]="{ 'offset-lg-4': row.isBatchNumberRequired }">
                    <button
                        class="w-20 btn btn-warning float-end"
                        type="button"
                        [attr.aria-label]="'PHYSICAL_INVENTORY_DELETE_ENTRY_ARIA_LABEL' | translate"
                        (click)="deleteSparePartRow()"
                    >
                        <fa-icon [icon]="faTrashAlt"></fa-icon>
                    </button>
                </div>
            }
        </div>
    </div>
</div>
